module.exports = __webpack_public_path__ + "img/setting_btn.7fa74241.png";